// extracted by mini-css-extract-plugin
export default {"disabled":"xwYpQYJzO2EehuNrAFf4","tabsList":"Pf5MQ46uC0konBXOttiW"};